module.exports = __webpack_public_path__ + "img/new-awards.dbd63c9.webp";